import { MatDialogRef } from '@angular/material/dialog';

export const closeMatDialog = (
  dialogRef: MatDialogRef<any, any>,
  dialogResult?: any,
  timeout = 1000,
) => {
  const animationStateChanged = dialogRef._containerInstance._animationStateChanged;

  dialogRef.close(dialogResult);

  setTimeout(() => {
    animationStateChanged.next({
      state: 'closing',
      totalTime: 0,
    });
    animationStateChanged.next({
      state: 'closed',
      totalTime: 0,
    });
    animationStateChanged.complete();
  }, timeout);
};
